import React from 'react';
import styles from '../../../../css/NavigatorBar/NavigatorContents/navScheduleContent.module.css';
import locationSVG from '../../../../assets/icons/svg/location.svg';
import ellipse from '../../../../assets/icons/svg/Ellipse_6.svg';
import dotLineSVG from '../../../../assets/icons/svg/dot-line.svg';
import { ReactComponent as DotIcon } from '../../../../assets/icons/svg/dot.svg';

// 항차별 일정 요약/상세를 모두 보여주는 스케줄 탭 컴포넌트
function changeDate(date) {
  if (!date) return { date: '', time: '' };
  const [d, t] = date.split(/T|\s/);
  return { date: d, time: t || '' };
}

function formatKoreanDate(isoDate) {
  if (!isoDate) return '';
  const dateStr = isoDate.split('T')[0];
  const [y, m, d] = dateStr.split('-').map(Number);
  const weekNames = ['일', '월', '화', '수', '목', '금', '토'];
  const dateObj = new Date(y, m - 1, d);
  const week = weekNames[dateObj.getDay()];
  return `${y}년 ${m}월 ${d}일(${week})`;
}

function NavScheduleContent(data, { forceMobile = false }) {
  // console.log('스케쥴 데이터',data)
  const simpleData = data.simple || [];
  const detailData = data.detail || [];
  const mapData = data.map;
  const [mapUrl, setMapUrl] = React.useState(typeof mapData === 'string' ? mapData : '');

  const [isMobile, setIsMobile] = React.useState(
    forceMobile || window.innerWidth <= 651
  );

  React.useEffect(() => {
    setMapUrl(typeof mapData === 'string' ? mapData : '');
  }, [mapData]);

  React.useEffect(() => {
    if (forceMobile) return;
    const handleResize = () => setIsMobile(window.innerWidth <= 651);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [forceMobile]);

  const handleMapError = React.useCallback(() => {
    setMapUrl('');
  }, []);

  return (
    <div className={styles['sailing-route-wrapper']}>
      {/* <div style={{ position: 'sticky', top: 0, zIndex: 9999, background: 'yellow', padding: '10px', border: '2px solid red', textAlign: 'center' }}>
        <p style={{ margin: 0, fontWeight: 'bold' }}>[진단 메시지]</p>
        <p style={{ margin: 0 }}>booking.js에서 받은 forceMobile 값: {String(data.forceMobile)}</p>
        <p style={{ margin: 0 }}>컴포넌트 isMobile 상태: {String(isMobile)}</p>
      </div> */}
      <div className={styles['sailing-route']}>
        {
          mapUrl && 
          <img
            src={mapUrl}
            alt="sailing-route-image"
            className={styles['sailing-route-image']}
            onError={handleMapError}
          />
        }

        <div className={styles['simple-schedule']}>
          <div className={styles['schedule-list']}>
            {simpleData.map((item, idx) => {
              const { date, time } = changeDate(item.date);
              const isFirst = idx === 0;
              const isLast = idx === simpleData.length - 1;

              return (
                <div className={styles.schedule} key={idx}>
                  <div className={styles['dot-line-wrap']}>
                    {!isFirst && (
                      <div
                        className={`${styles['dot-line']} ${styles.up}`}
                        style={{
                          background: `url(${dotLineSVG}) center center no-repeat`,
                        }}
                      />
                    )}
                    <div
                      className={styles.dot}
                      style={{
                        background: `url(${ellipse}) center center no-repeat`,
                      }}
                    />
                    {!isLast && (
                      <div
                        className={`${styles['dot-line']} ${styles.down}`}
                        style={{
                          background: `url(${dotLineSVG}) center center no-repeat`,
                        }}
                      />
                    )}
                  </div>

                  <div
                    className={styles['schedule-item']}
                    style={
                      !isLast
                        ? { paddingBottom: isMobile ? 20 : 22 }
                        : undefined
                    }
                  >
                    <div className={styles['schedule-item-badge']}>
                      {item.type === 'departure' ? '출발 일정' : '도착 일정'}
                    </div>
                    <div className={styles['schedule-item-info']}>
                      <div className={styles['schedule-date']}>
                        <span>{formatKoreanDate(date)}</span>
                        <span>{time}</span>
                      </div>
                      <div className={styles['schedule-location']}>
                        <img
                          src={locationSVG}
                          alt="location-image"
                          className={styles['location-image']}
                        />
                        {item.location}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* 상세 항해 경로 */}
      <div className={styles['detail-sailing-route']}>
        {detailData && detailData.length > 0 ? (
          detailData.map((item, idx) => {
            const showArrival = item.schedule.arrivetime && item.schedule.arrivetime !== '00:00:00';
            const showDeparture = item.schedule.departtime && item.schedule.departtime !== '00:00:00';

            // Port display logic
            const portDisplay = (() => {
              if (item.is_sea_day || item.type === 'sailing') {
                return <span>해상 (Cruise)</span>;
              }
              
              const portNameText = `${item.port.city_ko || item.port.city_en} (${item.port.raw_port_name})`;
              
              return (
                <>
                  <span className={styles.portName}>{portNameText}</span>
                  {(item.type === 'port' || item.type === 'tender') && (
                    <span className={`${styles.remark} ${item.type === 'port' ? styles.green : styles.red}`}>
                      <div className={styles.dotWrapper} style={{ margin: '0 2px' }}>
                        <DotIcon />
                      </div>
                      {item.type === 'port' ? '정박' : '텐더'}
                    </span>
                  )}
                </>
              );
            })();

            // Time display logic
            const timeDisplay = (() => {
              if (!showArrival && !showDeparture) {
                return null;
              }

              const timeClasses = [styles['detail-sailing-time']];
              if (showArrival && !showDeparture) {
                timeClasses.push(styles.departTime);
              } else if (!showArrival && showDeparture) {
                timeClasses.push(styles.arriveTime);
              }

              return (
                <div className={timeClasses.join(' ')}>
                  {showArrival && (
                    <div className={styles.arrival}>
                      <span>도착</span>
                      <span>{item.schedule.arrivetime.substring(0, 5)}</span>
                    </div>
                  )}
                  {showArrival && showDeparture && (
                    <div className={styles['divider_14']}></div>
                  )}
                  {showDeparture && (
                    <div className={styles.departure}>
                      <span>출발</span>
                      <span>{item.schedule.departtime.substring(0, 5)}</span>
                    </div>
                  )}
                </div>
              );
            })();

            return (
              <React.Fragment key={idx}>
                <div className={styles['detail-sailing-row']}>
                  <div className={styles['detail-sailing-info']}>
                    <div className={styles['detail-sailing-date']}>
                      {formatKoreanDate(item.schedule.arrivedate)}
                    </div>
                    <div className={styles['detail-sailing-port']}>
                      <img
                        src={locationSVG}
                        alt="location"
                        className={styles['location-icon']}
                      />
                      {portDisplay}
                    </div>
                  </div>
                  {timeDisplay}
                </div>
                {idx !== detailData.length - 1 && (
                  <div className={styles['detail-sailing-divider']} />
                )}
              </React.Fragment>
            );
          })
        ) : (
          <div className={styles['no-data']}>상세 항해정보가 없습니다.</div>
        )}
      </div>

      {/* remark 타입별 안내 */}
      <div className={styles['remark-type']}>
        <div className={styles.remark}>
          <div className={styles.dotWrapper}>
            <DotIcon />
          </div>
          <div className={styles['remark-content']}>
            <span className={styles.green}>정박</span>
            <span>: 항구 정박</span>
          </div>
        </div>
        <div className={styles.remark}>
          <div className={styles.dotWrapper}>
            <DotIcon />
          </div>
          <div className={styles['remark-content']}>
            <span className={styles.red}>텐더</span>
            <span>
              : 크루즈 선박이 바다에 닻을 내려 정박한 뒤, 작은 보트(텐더 보트)를 이용해
              승객을 육지로 이동시키는 항구
            </span>
          </div>
        </div>
      </div>

      {/* 안내사항 */}
      <div className={styles['detail-notis']}>
        <ul>
          <li>
              <div className={styles.noti} >
                <div className={styles.dotWrapper}>
                  <DotIcon />
                </div>
                <span className={styles['noti-content']}>표기된 모든 일정은 해당 지역의 현지 시간 기준입니다.</span>
              </div>
          </li>
          <li>
              <div className={styles.noti} >
                <div className={styles.dotWrapper}>
                  <DotIcon />
                </div>
                <span className={styles['noti-content']}>기재된 일정은 기상 변화, 천재지변, 기항지 및 항만 사정 등 현지 상황 또는 선사의 운영 사정에 따라 사전 예고 없이 변경될 수 있습니다.</span>
              </div>
          </li>
          <li>
              <div className={styles.noti} >
                <div className={styles.dotWrapper}>
                  <DotIcon />
                </div>
                <span className={styles['noti-content']}>선상 및 기항지에서의 활동, 여행 일정, 특이사항 및 탑승객 행동 수칙은 탑승하시는 크루즈 선박의 종류, 운항 일정 및 목적지에 따라 상이할 수 있으며, 이 역시 선사의 판단에 따라 예고 없이 변경될 수 있음을 양지하여 주시기 바랍니다.</span>
              </div>
          </li>
          <li>
              <div className={styles.noti} >
                <div className={styles.dotWrapper}>
                  <DotIcon />
                </div>
                <span className={styles['noti-content']}>승선 당일에는 크루즈 출항 시간 최소 3시간 전까지 크루즈 터미널에 도착하셔야 하며, 정해진 시간 이후에는 승선이 제한될 수 있으므로 여유 있는 일정으로 이동해 주시기 바랍니다.</span>
              </div>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default NavScheduleContent;
